module.exports = __webpack_public_path__ + "img/flag_95.b3c536ec.png";